import { forwardRef } from "react";
function SvgRawPresentIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={18}
        height={12}
        x={3}
        y={5}
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={1}
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m9 21 3-3 3 3M14 9H7m10 4H7"
      />
      <path
        stroke="#1D1D1D"
        strokeLinecap="round"
        strokeWidth={2}
        d="M12 5V3"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawPresentIcon);
export default ForwardRef;
